import React, { useEffect, useState } from 'react'
import axiosClient from 'axios-client'
import AddButton from 'components/Buttons/Add/AddButton'
import style from 'assets/css/Table.module.css'
import Filter from 'components/Filter'
import { Id, Role, Status, User } from 'types'
import { Link } from 'react-router-dom'
import { Table, TableColumnsType } from 'antd'
import TableOptions from 'components/Table/TableOptions'
import CustomTag from 'components/Buttons/Tag/CustomTag'
import { updateObject } from 'utils/updateObjectList'

const columns: TableColumnsType<User> = [
  {
    title: 'Full Name',
    dataIndex: ['firstname', 'lastname'],
    key: 'fullname',
    render: (_, { id, lastname, firstname }) => (
      <Link
        className={style.title}
        to={'/users/' + id}
      >
        {firstname + ' ' + lastname}
      </Link>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Roles',
    dataIndex: 'roles',
    key: 'roles',
    render: (_, { roles }) => (
      <>
        {roles?.map(roles => {
          return roles
        })}
      </>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: status => <CustomTag>{status}</CustomTag>,
  },
]

const Users: React.FC = () => {
  const [users, setUsers] = useState<User[]>([])
  const [loading, setLoading] = useState(false)

  const [selectedUsers, setSelectedUsers] = useState<Id[]>([])

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: User[]) => {
      //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      setSelectedUsers(selectedRowKeys as Id[])
    },
  }

  // Get enums
  const roles = Object.values(Role)
  const statusVal = Object.values(Status)
  // Datalist suggestions
  const suggestions: (Role | Status)[] = [...statusVal, ...roles]

  useEffect(() => {
    getUsers([])
  }, [])

  const getUsers = (filters: string[]) => {
    setLoading(true)

    axiosClient
      .get('/users', {
        params: {
          filters: filters,
        },
      })
      .then(({ data }) => {
        setLoading(false)
        setUsers(data)
      })
      .catch(({ errors }) => {
        setLoading(false)
      })
  }

  const updateUsersStatus = (field: string, newStatus: string) => {
    // Find the account by its ID
    const updatedAccounts = updateObject<User>({
      objects: users,
      selectedIds: selectedUsers,
      updateProperty: field,
      updateValue: newStatus,
    })

    // Update the state with the modified accounts array
    setUsers(updatedAccounts)
  }

  return (
    <>
      <div className={style.page_title}>
        <div className={style.label}>Users</div>
        <div className={style.count}>{users?.length} Users</div>
        {users && users.length > 0 && (
          <div style={{ marginLeft: 'auto' }}>
            <AddButton text="User" />
          </div>
        )}
      </div>
      <div className={style.box}>
        <Filter
          setFilters={getUsers}
          suggestions={suggestions.sort()}
        />

        <Table
          columns={columns}
          dataSource={users}
          rowSelection={{
            type: 'checkbox',
            fixed: true,
            ...rowSelection,
          }}
          pagination={{
            position: ['bottomCenter'],
            pageSizeOptions: [10, 20, 50],
            showSizeChanger: true,
          }}
          locale={{
            emptyText: (
              <div className={style.no_record}>
                <div className={style.text_wrapper}>
                  No user yet! Please click on the button bellow to add new user.
                </div>
                <AddButton text="User" />
              </div>
            ),
          }}
          //loading={true}
          rowKey={record => record.id}
          className={`${style.antTable}`}
          rowClassName={`${style.antRow}`}
          bordered
        />

        <TableOptions
          selectedRows={selectedUsers}
          type="users"
          updateObject={updateUsersStatus}
        />
      </div>
    </>
  )
}

export default Users
